import { QuestionBase } from './question-base';

/*

Sample:

new PasswordboxQuestion({
  key: 'password',
  label: 'nouns.password',
  required: true,
  order: 2
}),

*/
export class SimpleSelectQuestion extends QuestionBase<string> {
  controlType = 'simpleselect';
  items: object[];

  constructor(options: {} = {}) {
    super(options);
    this.items = options['items'] || [];
  }
}
